import { MainCol, MainContainer, MainRow } from "components/common";
import {
  LeftSide,
  MainFooter,
  UpperContainer,
  RightSide,
  FooterLink,
  IconContainer,
  Globe,
  Discord,
  Twitter,
  BottomContainer,
  BottomLeftContainer,
  BottomRightContainer,
  BottomLinks,
} from "./footerElement";

function Footer() {
  return (
    <MainFooter>
      <UpperContainer>
        <MainContainer>
          <LeftSide>
            <FooterLink>Explore</FooterLink>
            <FooterLink>Collection</FooterLink>
            <FooterLink>Rewards</FooterLink>
          </LeftSide>
          <RightSide>
            <IconContainer>
              <Globe />
              <Discord />
              <Twitter />
            </IconContainer>
          </RightSide>
        </MainContainer>
      </UpperContainer>
      <BottomContainer>
        <MainContainer>
          <BottomLeftContainer>
            Copyright 2022 LooksRare | By NFT people, for NFT people
          </BottomLeftContainer>
          <BottomRightContainer>
            <BottomLinks>Privacy Policy</BottomLinks>
            <BottomLinks className="mt-0">Terms Of Services</BottomLinks>
          </BottomRightContainer>
        </MainContainer>
      </BottomContainer>
    </MainFooter>
  );
}

export default Footer;
